<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div>
  <app-module-header [showImportExportBtn]="showImportExportBtn" [showLastSync]="false"></app-module-header>
</div>


<p-tabView>
  <p-tabPanel>
    <ng-template pTemplate="header">
      <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
      <span
        class="tab-label" translate>lbl_details</span>&nbsp;<span
        class="iconNumber text-color-secondary"></span>
    </ng-template>

    <div class="card m-4 border-radius-10">
      <div class="card-body">
        <form [formGroup]="filterForm">
          <div class="formgrid grid col-6">
            <div class="col-12 field">
              <label class="block mb-2 field-label">{{ 'reports.lbl_protocol' | translate }}</label>
              <p-multiSelect
                [options]="protocolOptions"
                formControlName="protocolId"
                [placeholder]="'reports.select_protocol' | translate"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                [showClear]="true"
                [maxSelectedLabels]="2"
                selectedItemsLabel="{0} protocols selected"
                styleClass="w-full"
                class="w-full block">
              </p-multiSelect>
            </div>

            <!-- Site Filter -->
            <div class="col-12 field">
              <label class="block mb-2 field-label">{{ 'reports.lbl_site' | translate }}</label>
              <p-multiSelect
                [options]="siteOptions"
                formControlName="siteId"
                [placeholder]="'reports.select_site' | translate"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                [showClear]="true"
                [maxSelectedLabels]="2"
                selectedItemsLabel="{0} sites selected"
                styleClass="w-full"
                class="w-full block">
              </p-multiSelect>
            </div>

            <!-- Second Row: Date Ranges -->
            <!-- Order Creation Date Range -->
            <div class="col-6 field">
              <label class="block mb-2 field-label">{{ 'reports.lbl_order_creation_date' | translate }}</label>
              <div [ngClass]="{'field-error': hasDateRangeError('orderCreationDateRange')}">
                <p-calendar
                  formControlName="orderCreationDateRange"
                  [selectionMode]="'range'"
                  [placeholder]="'reports.select_date_range' | translate"
                  [showIcon]="true"
                  [dateFormat]="'dd/mm/yy'"
                  [maxDate]="maxDate"
                  appendTo="body"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                  class="w-full">
                </p-calendar>
              </div>
              <small 
                *ngIf="hasDateRangeError('orderCreationDateRange')" 
                class="p-error block mt-1">
                {{ getDateRangeErrorMessage('orderCreationDateRange') }}
              </small>
            </div>

            <!-- Order Received Date Range -->
            <div class="col-6 field">
              <label class="block mb-2 field-label">{{ 'reports.lbl_order_received_date' | translate }}</label>
              <div [ngClass]="{'field-error': hasDateRangeError('orderReceivedDateRange')}">
                <p-calendar
                  formControlName="orderReceivedDateRange"
                  [selectionMode]="'range'"
                  [placeholder]="'reports.select_date_range' | translate"
                  [showIcon]="true"
                  [dateFormat]="'dd/mm/yy'"
                  [maxDate]="maxDate"
                  appendTo="body"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                  class="w-full">
                </p-calendar>
              </div>
              <small 
                *ngIf="hasDateRangeError('orderReceivedDateRange')" 
                class="p-error block mt-1">
                {{ getDateRangeErrorMessage('orderReceivedDateRange') }}
              </small>
            </div>

            <!-- Third Row: Download Button -->
            <div class="col-12 text-right mt-3">
              <p-button
                [label]="isDownloading ? ('reports.downloading' | translate) : ('reports.download_report' | translate)"
                [icon]="'pi pi-download'"
                [disabled]="isDownloading || filterForm.invalid"
                [loading]="isDownloading"
                (onClick)="downloadReport()">
              </p-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>